const IS_DEBUG = import.meta.env.REACT_APP_DEBUG === "true";

export const debugLog = (...args: unknown[]): void => {
  if (IS_DEBUG) {
    console.log(...args);
  }
};

export const debugWarn = (...args: unknown[]): void => {
  if (IS_DEBUG) {
    console.warn(...args);
  }
};

export const debugError = (...args: unknown[]): void => {
  if (IS_DEBUG) {
    console.error(...args);
  }
};

export const debugInfo = (...args: unknown[]): void => {
  if (IS_DEBUG) {
    console.info(...args);
  }
};

export const debugDebug = (...args: unknown[]): void => {
  if (IS_DEBUG) {
    console.debug(...args);
  }
};
